import { resourceFromAttributes } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';

export const resource = resourceFromAttributes({
  [ATTR_SERVICE_NAME]: 'central-web',
});
